import Form, { InputType } from '../../lib/Formik';
import { OtpField, ResendOtp, useTimer } from '../../lib/OtpField';
import en from '../../lang/en-us';
import { FormikHelpers, useFormik } from 'formik';
import { connect } from 'react-redux';
import {
    onResendLoginOTP as resendOtp,
    verifyOtp,
    forgotQuestionAnswerOtp,
} from '../../redux-store/actions/login';
import { useEffect, useMemo } from 'react';
import { useState } from 'react';
import { addDialCode, OTP_ACTIONS } from '../../utils/constants';
import { FORGOT_QA } from '../../redux-store/types/login';

const { signupOtp, forgotPassword, common } = en;

const initOTPInfo = {
    reqId: '',
    otpRef: '',
};

const formFields: Partial<InputType>[] = [
    {
        component: OtpField,
        name: 'otp',
    },
];

const initialValues = {
    otp: new Array(6).fill(''),
};

function ResetQuestionOtp(props: any) {
    const { mobile = '', email = '', reqId, otpRef, ...rest } = props.location.state || {};
    const { timer, resetTimer, startTimer } = useTimer({});
    const [otpInfo, setOtpInfo] = useState<{ reqId: string; otpRef: string }>(initOTPInfo);

    const onVerify = async (
        values: { otp: string[] },
        action: FormikHelpers<{ otp: string[] }>,
    ) => {
        if (values.otp.join('').length !== 6) {
            action.setSubmitting(false);
            alert(common.noOtp);
            return;
        }
        const payload: any = {
            ...otpInfo,
            enteredOtp: values.otp.join(''),
            mobile: mobile && addDialCode(mobile),
            email,
            pan: '',
            pekrn: rest.pekrn,
            action: FORGOT_QA,
            userId: rest.pan,
        };
        try {
            await props.verifyOtp(payload);
            props.history.push(`/reset-questionnaire`, {
                ...payload,
            });
        } catch (err: any) {
            alert(err.message);
        }
        action.setSubmitting(false);
    };

    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: onVerify,
    });

    useEffect(() => {
        // if (!mobile || !email) {
        //     props.history.push('signin');
        //     return;
        // }
        setOtpInfo({ otpRef: otpRef, reqId: reqId });
    }, []);

    const onResend = async () => {
        try {
            let res = await props.resendOtp({
                otpRef: otpRef,
                reqId: reqId,
                action: FORGOT_QA,
            });
            resetTimer();
            setOtpInfo({ ...(res || {}).body });
            formik.setValues({ otp: new Array(6).fill('') });
        } catch (err: any) {
            alert(err.message);
        }
    };
    const _Form = useMemo(() => {
        return <Form ui={formFields} formik={formik} submitButtonLabel="Verify OTP"></Form>;
    }, [formik]);
    return (
        <div className="signup-padding">
            <div className="signup-progress">
                <span className="active"></span>
                <span></span>
                <span></span>
            </div>

            <h2
                className="text-center"
                style={{
                    fontSize: '22px',
                    fontWeight: 'normal',
                    color: '#333',
                    fontFamily: 'Montserrat-SemiBold',
                    lineHeight: 'normal',
                }}
            >
                {signupOtp.heading}
            </h2>
            <p className="otp-sent-info text-center subheading">
                OTP sent to Registered Email/Mobile
            </p>
            {_Form}
            <ResendOtp counter={timer} onResendOtp={onResend} startTimer={startTimer} />
        </div>
    );
}

export default connect(null, { verifyOtp, resendOtp, forgotQuestionAnswerOtp })(ResetQuestionOtp);
